import { publicClient, privateClient } from './client';
import { HdmCart } from './HdmCart';

const customHdmCart = (pub: boolean) => new HdmCart(pub ? publicClient : privateClient);
export default customHdmCart;
